const searchHandler = () => { 
    let openSearchBtn = document.querySelector(".search__button");
    let iconOpen = document.querySelector(".button-icon-open");
    let iconClose = document.querySelector(".button-icon-close");
    let searchForm = document.querySelector(".search__form-search");

    openSearchBtn.addEventListener("click", () => {

        if( openSearchBtn.classList.contains("open") ) {

            openSearchBtn.classList.remove("open");

            iconOpen.style.display = "block";
            iconClose.style.display = "none";
    
            searchForm.style.opacity = "0";
            searchForm.style.visibility = "hidden";
            searchForm.style.zIndex = "-100";
        } else {

            openSearchBtn.classList.add("open");
            iconOpen.style.display = "none";
            iconClose.style.display = "block";
    
            searchForm.style.opacity = "1";
            searchForm.style.visibility = "visible";
            searchForm.style.zIndex = "99999";

            openSearchBtn.classList.add("open");
        }
    });


}

export default searchHandler;